
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSatelliteOff as ObiSatelliteOffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-satellite-off.js';
 
 
 

 
 export const ObiSatelliteOff = createComponent({
   react: React,
   tagName: 'obi-satellite-off',
   elementClass: ObiSatelliteOffElement,
   events: {
     
   }
  });
 
 